// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";
import { instancesDeclaration } from "core/Shaders/ShadersInclude/instancesDeclaration";
import { sceneVertexDeclaration } from "core/Shaders/ShadersInclude/sceneVertexDeclaration";
import { sceneUboDeclaration } from "core/Shaders/ShadersInclude/sceneUboDeclaration";
import { logDepthDeclaration } from "core/Shaders/ShadersInclude/logDepthDeclaration";
import { fogVertexDeclaration } from "core/Shaders/ShadersInclude/fogVertexDeclaration";
import { clipPlaneVertexDeclaration } from "core/Shaders/ShadersInclude/clipPlaneVertexDeclaration";
import { instancesVertex } from "core/Shaders/ShadersInclude/instancesVertex";
import { fogVertex } from "core/Shaders/ShadersInclude/fogVertex";
import { clipPlaneVertex } from "core/Shaders/ShadersInclude/clipPlaneVertex";
import { logDepthVertex } from "core/Shaders/ShadersInclude/logDepthVertex";

const name = "gridVertexShader";
const shader = `precision highp float;attribute vec3 position;attribute vec3 normal;
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#include<instancesDeclaration>
#include<__decl__sceneVertex>
varying vec3 vPosition;varying vec3 vNormal;
#if defined(HORIZON_FADE) || defined(BELOW_LINE_COLOR) || defined(ORIGIN_MARKER)
varying vec3 vWorldPos;
#endif
#include<logDepthDeclaration>
#include<fogVertexDeclaration>
#ifdef OPACITY
varying vec2 vOpacityUV;uniform mat4 opacityMatrix;uniform vec2 vOpacityInfos;
#endif
#include<clipPlaneVertexDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
#include<instancesVertex>
vec4 worldPos=finalWorld*vec4(position,1.0);
#include<fogVertex>
vec4 cameraSpacePosition=view*worldPos;gl_Position=projection*cameraSpacePosition;
#ifdef OPACITY
#ifndef UV1
vec2 uv=vec2(0.,0.);
#endif
#ifndef UV2
vec2 uv2=vec2(0.,0.);
#endif
if (vOpacityInfos.x==0.)
{vOpacityUV=vec2(opacityMatrix*vec4(uv,1.0,0.0));}
else
{vOpacityUV=vec2(opacityMatrix*vec4(uv2,1.0,0.0));}
#endif 
#include<clipPlaneVertex>
#include<logDepthVertex>
vPosition=position;vNormal=normal;
#if defined(HORIZON_FADE) || defined(BELOW_LINE_COLOR) || defined(ORIGIN_MARKER)
vWorldPos=worldPos.xyz;
#endif
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
if (!ShaderStore.ShadersStore[name]) {
    ShaderStore.ShadersStore[name] = shader;
}
const includes = [instancesDeclaration, sceneVertexDeclaration, sceneUboDeclaration, logDepthDeclaration, fogVertexDeclaration, clipPlaneVertexDeclaration, instancesVertex, fogVertex, clipPlaneVertex, logDepthVertex];
for (const inc of includes) {
    if (!ShaderStore.IncludesShadersStore[inc.name]) {
        ShaderStore.IncludesShadersStore[inc.name] = inc.shader;
    }
}

/** @internal */
export const gridVertexShader = { name, shader };
